import { axiosClient } from './AxiosClient'

function addDepartment(departmentName, companyId, callback, errorCallback){
    let url = "/department/admin/create";

    var bodyForm = new FormData()
    bodyForm.append("department_name", departmentName)
    bodyForm.append("company_id", companyId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })

}

function removeDepartment(departmentId, callback, errorCallback){
    let url = "/department/admin/delete";

    var bodyForm = new FormData()
    bodyForm.append("department_id", departmentId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function listDepartment(companyId, callback, errorCallback){
    let url = "/department/admin/list_all";

    var bodyForm = new FormData()
    bodyForm.append("company_id", companyId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function addUserToDepartment(userId, departmentId, callback, errorCallback){
    let url = "/account/admin/add_department";

    var bodyForm = new FormData()
    bodyForm.append("user_id", userId)
    bodyForm.append("department_id", departmentId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function removeFromDepartment(userId, departmentId, callback, errorCallback){
    let url = "/account/admin/remove_department";

    var bodyForm = new FormData()
    bodyForm.append("user_id", userId)
    bodyForm.append("department_id", departmentId)

    axiosClient.post(url, bodyForm)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { addDepartment, listDepartment, removeDepartment, addUserToDepartment, removeFromDepartment }